module.exports = __webpack_public_path__ + "static/media/verifyShgKan.b89765d5.jpg";